import * as Sentry from '@sentry/react';

const dsn = process.env.REACT_APP_SENTRY_DSN;

if (!dsn) {
  console.warn('[Sentry] REACT_APP_SENTRY_DSN is not set — Sentry disabled');
} else {
  Sentry.init({
    dsn,
    environment: process.env.REACT_APP_VERCEL_ENV || process.env.NODE_ENV || 'development',
    release: process.env.REACT_APP_VERCEL_GIT_COMMIT_SHA,
    sendDefaultPii: process.env.REACT_APP_SENTRY_SEND_PII === 'true',
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}
